import { getL11nString } from "@/l11n/l11n";

export default function ContactUs() {
  return (
    <div className="flex flex-col items-center text-center p-4 space-y-3">
      <h2 className="text-xl font-semibold mb-2">{getL11nString("contact_us")}</h2>
      <div className="text-md mb-2">{getL11nString("contact_us_detail")}</div>
      <a href="mailto:team@taalia.com" target="_blank" rel="noreferrer">
        team@taalia.com
      </a>
      <a href="https://www.taalia.com" target="_blank" rel="noreferrer">
        {getL11nString("taalia_home")}
      </a>
    </div>
  );
}
